// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_pagination__1HEbv button, .style_pagination__1HEbv div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_interface_heading_row__gvyB4 {
  display: flex;
  align-items: center;
}

.style_interface_noResults__DskJz {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_container_fields_row__bU97L {
  display: flex;
  justify-content: space-between;
}

.style_container_fields__Etlev, .style_container_fields_input__dyDvM, .style_interface__6TtM\\+ {
  display: flex;
  flex-direction: column;
}

.style_container_fields_actions__MW598 {
  display: flex;
  justify-content: flex-end;
}

a {
  text-decoration: none;
}

.style_link__1hX1F {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__1hX1F:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__ihF1A {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__eNMro {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__NqMS9, .style_interface_heading__7avc3, .style_interface_footer__AkYJ2 {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__tgHAf {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__\\+FCvV {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__\\+FCvV {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__XMKVF {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__XMKVF {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__l4d1c {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__l4d1c {
    line-height: 1.5rem;
  }
}

.style_breadcumb__S4OTU {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__S4OTU a,
.style_breadcumb__S4OTU span {
  padding: 3px 5px;
}
.style_breadcumb__S4OTU a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__S4OTU a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__S4OTU .style_divider__dvk0d {
  color: var(--color-gray-400);
}

.style_badge__ah2wX {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__ah2wX.style_xs__tS1w\\+ {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__ah2wX.style_sm__L2XnE {
  padding: 4px 7px;
}
.style_badge__ah2wX.style_primary__UT38D {
  background: var(--color-primary-500);
}
.style_badge__ah2wX.style_primary__UT38D, .style_badge__ah2wX.style_pm__nQM1z {
  background: var(--color-primary-500);
}
.style_badge__ah2wX.style_sd__bzkY9 {
  background-color: var(--color-secundary-500);
}
.style_badge__ah2wX.style_Likely__Lvrg9 {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__ah2wX.style_Unvalidated__WcRvx {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__ah2wX.style_Verified__\\+neNh, .style_badge__ah2wX.style_green__RovDR {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__ah2wX.style_off__Q25mw {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__lkx9i {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__lkx9i.style_xs__tS1w\\+ {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__lkx9i.style_sm__L2XnE {
  padding: 4px 7px;
}
.style_badgeTable__lkx9i.style_primary__UT38D, .style_badgeTable__lkx9i.style_pm__nQM1z {
  background: var(--color-primary-500);
}
.style_badgeTable__lkx9i.style_sd__bzkY9 {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__lkx9i.style_Likely__Lvrg9 {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__lkx9i.style_Verified__\\+neNh, .style_badgeTable__lkx9i.style_green__RovDR {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__lkx9i.style_off__Q25mw {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__qq9eI {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__qq9eI.style_style-1__KRnT8 td,
.style_table__qq9eI.style_style-1__KRnT8 th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__qq9eI.style_style-1__KRnT8 th,
.style_table__qq9eI.style_style-1__KRnT8 td.style_label__71byy {
  color: var(--color-white-500);
}
.style_table__qq9eI.style_style-1__KRnT8 th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__qq9eI.style_style-1__KRnT8 tr.style_noBorder__6bsOV td {
  border-bottom: none;
}
.style_table__qq9eI.style_style-1__KRnT8 tr td {
  color: var(--color-white-500);
}

.style_pagination__1HEbv {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__1HEbv button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__1HEbv button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__1HEbv button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__1HEbv button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__1HEbv button.style_disabled__\\+ixFy, .style_pagination__1HEbv button.style_active__0g-Qm, .style_pagination__1HEbv button.style_info__eoSz5 {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__1HEbv button.style_disabled__\\+ixFy {
  color: var(--color-gray-700);
}
.style_pagination__1HEbv div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__1HEbv div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__1HEbv div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__1HEbv div:hover, .style_pagination__1HEbv div.style_active__0g-Qm {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__1HEbv div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__1HEbv div.style_disabled__\\+ixFy, .style_pagination__1HEbv div.style_active__0g-Qm, .style_pagination__1HEbv div.style_info__eoSz5 {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__1HEbv div.style_disabled__\\+ixFy {
  color: var(--color-gray-700);
}
.style_pagination__1HEbv div:last-child, .style_pagination__1HEbv div:first-child {
  padding: 0 10px;
}
.style_pagination__1HEbv div:last-child {
  border-right: none;
}
.style_pagination__1HEbv button:last-child, .style_pagination__1HEbv button:first-child {
  padding: 0 10px;
}
.style_pagination__1HEbv button:last-child {
  border-right: none;
}

.style_interface__6TtM\\+ {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__7avc3 {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__7avc3 {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__7avc3 > div {
    width: 100%;
  }
}
.style_interface_heading_row__gvyB4 {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__gvyB4 {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__AkYJ2 {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__AkYJ2 {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__AkYJ2 > div {
    width: 100%;
  }
}
.style_interface_foot__9G9Qb {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__9G9Qb {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__DskJz {
  gap: 15px;
  padding: 70px 0;
}

.style_container_fields__Etlev {
  background-color: var(--dark-bg);
  gap: 20px;
  padding: 25px;
  border-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_container_fields__Etlev {
    padding: 18px;
  }
}
.style_container_fields_input__dyDvM {
  gap: 7px;
  width: 100%;
}
.style_container_fields_row__bU97L {
  width: 100%;
  gap: 24px;
}
@media only screen and (max-width: 780px) {
  .style_container_fields_row__bU97L {
    flex-direction: column;
    gap: 20px;
  }
}
.style_container_fields_actions__MW598 button {
  width: max-content;
}
.style_container_fields_actions__MW598 button:hover:not([disabled]) {
  background: linear-gradient(var(--main-color), rgba(0, 0, 0, 0.7)) top/100% 900%;
}
@media only screen and (max-width: 780px) {
  .style_container_fields_actions__MW598 button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_flex.scss","webpack://./src/components/molecules/AccountSettings/style.module.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;ACCF;;ADaA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACVF;;ADwBA;EACE,aAAA;EACA,8BAAA;ACrBF;;ADwBA;EACE,aAAA;EACA,sBAAA;ACrBF;;AD2CA;EACE,aAAA;EACA,yBAAA;ACxCF;;ACvBA;EACI,qBAAA;AD0BJ;;ACxBA;EACI,eAAA;EACA,cAAA;AD2BJ;AC1BI;EACE,0BAAA;AD4BN;;ACxBA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AD2BJ;;ACxBI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;AD2BR;ACzBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;AD2BR;ACzBI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;AD2BR;ACzBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AD2BR;AEnEE;EDsCE;IAIQ,eAAA;IACA,mBAAA;ED6BV;AACF;AC3BI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AD6BR;AE7EE;ED8CE;IAIQ,eAAA;IACA,mBAAA;ED+BV;AACF;AC7BI;EACI,mBAAA;AD+BR;AEtFE;EDsDE;IAGQ,mBAAA;EDiCV;AACF;;AGzFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AH4FF;AG3FE;;EAEE,gBAAA;AH6FJ;AG3FE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AH6FJ;AG5FI;EACE,+BAAA;EACA,uCAAA;AH8FN;AG3FE;EACE,4BAAA;AH6FJ;;AIjHA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJoHF;AIjHE;EACE,gBAAA;EACA,eAAA;AJmHJ;AIjHE;EACE,gBAAA;AJmHJ;AI/GE;EACE,oCAAA;AJiHJ;AI/GE;EAEE,oCAAA;AJgHJ;AI9GE;EACE,4CAAA;AJgHJ;AI9GE;EACE,uCAAA;EACA,mCAAA;AJgHJ;AI9GE;EACE,oCAAA;EACA,gCAAA;AJgHJ;AI9GE;EAEE,4CAAA;EACA,kCAAA;AJ+GJ;AI7GE;EACE,6BAAA;EACA,uCAAA;AJ+GJ;;AI5GA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJ+GF;AI5GE;EACE,gBAAA;EACA,eAAA;AJ8GJ;AI5GE;EACE,gBAAA;AJ8GJ;AI1GE;EAEE,oCAAA;AJ2GJ;AIzGE;EACE,4CAAA;AJ2GJ;AIzGE;EACE,mBAAA;EACA,cAAA;AJ2GJ;AIzGE;EAEE,4CAAA;EACA,kCAAA;AJ0GJ;AIxGE;EACE,6BAAA;EACA,uCAAA;AJ0GJ;;AKlMA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;ALqMF;AKnMI;;EAEE,kBAAA;EACA,mBAAA;ALqMN;AKnMI;;EAEE,6BAAA;ALqMN;AKnMI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;ALqMN;AKlMM;EACE,mBAAA;ALoMR;AKlMM;EACE,6BAAA;ALoMR;;AMxNA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;AN0NJ;AMxNI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANyNR;AMxNQ;EACI,2BAAA;EACA,8BAAA;AN0NZ;AMxNQ;EACI,4BAAA;EACA,+BAAA;AN0NZ;AEzPE;EIgBE;IAkBQ,eAAA;IACA,eAAA;EN2NV;AACF;AM1NQ;EACI,eAAA;EACA,oBAAA;AN4NZ;AM1NQ;EACI,4BAAA;AN4NZ;AMzNI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;AN0NR;AMzNQ;EACI,2BAAA;EACA,8BAAA;AN2NZ;AMzNQ;EACI,4BAAA;EACA,+BAAA;AN2NZ;AMzNQ;ECrCJ,eAAA;EACA,qFAAA;APiQJ;AE3RE;EI6CE;IAqBQ,eAAA;IACA,eAAA;EN6NV;AACF;AM5NQ;EACI,eAAA;EACA,oBAAA;AN8NZ;AM5NQ;EACI,4BAAA;AN8NZ;AM3NI;EACI,eAAA;AN6NR;AM3NI;EACI,kBAAA;AN6NR;AM3NI;EACI,eAAA;AN6NR;AM3NI;EACI,kBAAA;AN6NR;;AQ/SA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;ARkTF;AQhTE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARiTJ;AEzUE;EMeA;IAWI,kBAAA;IACA,uBAAA;ERmTJ;EQlTI;IACE,WAAA;ERoTN;AACF;AQlTI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;ARmTN;AEvVE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ERqTN;AACF;AQlTE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARmTJ;AEvWE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ERqTJ;EQpTI;IACE,WAAA;ERsTN;AACF;AQnTE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;ARqTJ;AErXE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ERuTJ;AACF;AQrTE;EAEE,SAAA;EACA,eAAA;ARsTJ;;AA7XE;EAEE,gCSFM;ETGN,SAAA;EACA,aAAA;EACA,kBAAA;AA+XJ;AEtYE;EFEA;IAMoB,aAAA;EAkYpB;AACF;AAjYI;EAEE,QAAA;EACA,WAAA;AAkYN;AA/XI;EAEE,WAAA;EACA,SAAA;AAgYN;AE3XE;EFRE;IAMI,sBAAA;IACA,SAAA;EAiYN;AACF;AA5XM;EACE,kBAAA;AA8XR;AA7XQ;EACE,gFAAA;AA+XV;AEvYE;EFKI;IAMI,WAAA;EAgYR;AACF","sourcesContent":["%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"/src/assets/scss/\" as *;\n\n.container {\n  &_fields {\n    @extend %flex-column;\n    background-color: $dark-bg;\n    gap: 20px;\n    padding: 25px;\n    border-radius: 8px;\n    @include mobile { padding: 18px; }\n\n    &_input {\n      @extend %flex-column;\n      gap: 7px;\n      width: 100%;\n    }\n\n    &_row {\n      @extend %flex-justify-between;\n      width: 100%;\n      gap: 24px;\n\n      @include middleTablet {\n        flex-direction: column;\n        gap: 20px;\n      }\n    }\n\n    &_actions {\n      @extend %flex-align-end;\n      button {\n        width: max-content;\n        &:hover:not([disabled]) {\n          background: linear-gradient($main-color, rgb(0 0 0/70%)) top/100% 900%;\n        }\n        @include middleTablet {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `style_pagination__1HEbv`,
	"interface_heading_row": `style_interface_heading_row__gvyB4`,
	"interface_noResults": `style_interface_noResults__DskJz`,
	"container_fields_row": `style_container_fields_row__bU97L`,
	"container_fields": `style_container_fields__Etlev`,
	"container_fields_input": `style_container_fields_input__dyDvM`,
	"interface": `style_interface__6TtM+`,
	"container_fields_actions": `style_container_fields_actions__MW598`,
	"link": `style_link__1hX1F`,
	"text-gradient-intel": `style_text-gradient-intel__ihF1A`,
	"text-xs": `style_text-xs__eNMro`,
	"text-sm": `style_text-sm__NqMS9`,
	"interface_heading": `style_interface_heading__7avc3`,
	"interface_footer": `style_interface_footer__AkYJ2`,
	"text-base": `style_text-base__tgHAf`,
	"text-lg": `style_text-lg__+FCvV`,
	"text-xl": `style_text-xl__XMKVF`,
	"text-leading": `style_text-leading__l4d1c`,
	"breadcumb": `style_breadcumb__S4OTU`,
	"divider": `style_divider__dvk0d`,
	"badge": `style_badge__ah2wX`,
	"xs": `style_xs__tS1w+`,
	"sm": `style_sm__L2XnE`,
	"primary": `style_primary__UT38D`,
	"pm": `style_pm__nQM1z`,
	"sd": `style_sd__bzkY9`,
	"Likely": `style_Likely__Lvrg9`,
	"Unvalidated": `style_Unvalidated__WcRvx`,
	"Verified": `style_Verified__+neNh`,
	"green": `style_green__RovDR`,
	"off": `style_off__Q25mw`,
	"badgeTable": `style_badgeTable__lkx9i`,
	"table": `style_table__qq9eI`,
	"style-1": `style_style-1__KRnT8`,
	"label": `style_label__71byy`,
	"noBorder": `style_noBorder__6bsOV`,
	"disabled": `style_disabled__+ixFy`,
	"active": `style_active__0g-Qm`,
	"info": `style_info__eoSz5`,
	"interface_foot": `style_interface_foot__9G9Qb`
};
export default ___CSS_LOADER_EXPORT___;
